var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0.555556L15.5556 5V1.11111C15.5556 0.497461 15.0581 0 14.4444 0H1.11111C0.497461 0 0 0.497461 0 1.11111V12.2222C0 12.8359 0.497461 13.3333 1.11111 13.3333H14.4444C15.0581 13.3333 15.5556 12.8359 15.5556 12.2222V8.33333L20 12.7778V0.555556ZM6.88889 6.46667L8.78889 3.94444L13.3333 10H2.22222L5.25556 5.95556L7.52222 8.98889L8.33333 8.38889L6.88889 6.46667Z",
    fill: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.0649b0782df4ada26451a5840bfa2acc.svg";
export { ForwardRef as ReactComponent };